import { Box, Text } from "@chakra-ui/react";

type Props = { title: string; children: React.ReactNode };

const DetailSection = ({ title, children }: Props): JSX.Element => (
  <Box>
    <Text fontWeight={700} color="gray.700" mb={3}>
      {title}
    </Text>
    {children}
  </Box>
);

export default DetailSection;
